import validate from 'validate.js';
import { defineMessages } from 'react-intl';

const validateBookingOvertimeForm = (values) => {
  const {
    hours,
    rate
  } = values;

  const intlMessages = defineMessages({
    hours: {
      id: 'inbox_bookingID_overtime.validate_booking_overtime_form.hours',
      defaultMessage: 'Please select an option.'
    },
    rate: {
      id: 'inbox_bookingID_overtime.validate_booking_overtime_form.rate',
      defaultMessage: 'Please select an option.'
    }
  });

  return {
    hours: validate.single(hours, {
      presence: {
        allowEmpty: false,
        message: intlMessages.hours
      }
    }),
    rate: validate.single(rate, {
      presence: {
        allowEmpty: false,
        message: intlMessages.rate
      }
    })
  };
};

export default validateBookingOvertimeForm;
